// extracted by mini-css-extract-plugin
export default {"cardLegend":"OverviewChartLegend_cardLegend__pYLfj"};